import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tooltipButton", "tooltipText"];

  handleMouseover() {
    this.updateTooltipPosition();
    this.toggleTooltipVisibility();
  }

  handleMouseout() {
    this.hideTooltip();
  }

  updateTooltipPosition() {
    const shouldShowBelow = this.shouldShowTooltipBelow();
    this.tooltipTextTarget.classList.toggle('tooltip-under', shouldShowBelow);
  }

  shouldShowTooltipBelow() {
    const isVisible = this.isTooltipVisible();
    return !!this.tooltipTextTarget.dataset.dynamic && !isVisible && !this.isMoreSpaceAbove();
  }

  toggleTooltipVisibility() {
    const isVisible = this.isTooltipVisible();
    this.tooltipTextTarget.style.visibility = isVisible ? "hidden" : "visible";
  }

  hideTooltip() {
    this.tooltipTextTarget.style.visibility = 'hidden';
    this.tooltipTextTarget.classList.remove('tooltip-under');
  }

  isTooltipVisible() {
    return this.tooltipTextTarget.style.visibility === "visible";
  }

  isMoreSpaceAbove() {
    const rect = this.tooltipButtonTarget.getBoundingClientRect();
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;
    return spaceAbove > spaceBelow;
  }
}
